namespace Matrix.Rebalancer {
    export class SummaryViewFormatColumns {
        static columnsKey = 'Rebalancer.SummaryViewFormat';
    }
}
